import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const fetchSeverityTypes = (customer) => {
  return axios({
    url: `/rule/${customer}/types`,
    method: 'get'
  });
};

const useGetSeverityTypes = (customer) => {
  return useQuery(['severity_types', customer], () => fetchSeverityTypes(customer), {
    enabled: !!customer
  });
};

export default useGetSeverityTypes;
